/**
 * Description-class field length limits — single source of truth.
 *
 * Purpose
 * -------
 * Centralizes the maximum character lengths for description-style fields
 * (free-form long-text fields and short summaries) used across CompBox
 * packages. Keeping these in @mycompbox/shared ensures that API validators,
 * MCP tool input schemas, and any future consumers all enforce identical
 * caps without drift.
 *
 * Consumer contract
 * -----------------
 * Downstream sites SHOULD import constants from this module rather than
 * inlining numeric literals. The full set of consumers changes over time,
 * so avoid maintaining a hard-coded list here.
 *
 * When changing any limit in this module, audit the repository for both
 * shared-constant imports and any remaining raw numeric literals that may
 * enforce the same cap:
 *
 *   - repo search for DESCRIPTION_MAX / APPEND_DESCRIPTION_MAX / SUMMARY_MAX
 *   - repo search for matching raw literals (1_000_000, 5_000) where drift
 *     is plausible
 *   - audit database-layer constraints where relevant — validator changes
 *     must remain compatible with persisted storage limits and column
 *     definitions, especially for long-text description-style fields
 *
 * Canonical pattern
 * -----------------
 * This module generalizes the pattern established by
 * packages/api/src/schemas/epicRequest.ts under ENG-E177, which proved that
 * shared numeric caps avoid silent divergence between layers.
 */
/** Maximum length (in characters) for a full description field replacement. */
export const DESCRIPTION_MAX = 1_000_000;
/** Maximum length (in characters) for content appended to an existing description. */
export const APPEND_DESCRIPTION_MAX = 1_000_000;
/** Maximum length (in characters) for short summary fields. */
export const SUMMARY_MAX = 5_000;
//# sourceMappingURL=description-limits.js.map